import { PackageCards } from "@/components/home/PackageCards";
import { Comparison } from "@/components/home/Comparison";
import { FinalCTA } from "@/components/home/FinalCTA";
import { useSeo } from "@/lib/seo";

export default function Packages() {
    useSeo({ title: "Digital Growth Packages — Starter, Growth & Business Pro | SUDIGI", description: "Transparent monthly digital marketing packages for Indian businesses. Starter ₹999, Growth ₹2,999, Business Pro ₹5,999." });
    return (
        <>
            <div className="pt-8"><PackageCards /></div>
            <Comparison />
            <FinalCTA />
        </>
    );
}
